import React, { useState, memo, useRef, useEffect } from "react";
import Formsy from "formsy-react";
// import { MySelect } from "../../Shared/Forms/Select";
import { TextInput } from "../Shared/Forms";
import { Row, Col, Button, Spinner, UncontrolledAlert } from "reactstrap";
import { MdSave } from "react-icons/md";

//import { upLoadService } from "../../Shared/Forms/UploadImageService";

const WaterSettingForm = memo((props) => {
    const { submitted, submitting, handleSubmit, formError} = props;
    const waterSettingFormRef = useRef("waterSettingForm");

    // validation states
    const [canSubmit, setCanSubmit] = useState(false);
    const [resetvalue, setResetValue] = useState(0);
    const submitGeneralMealPlan = (e) => {
        //please don't forget to parse the string to float
        try {
            if (e) {
                let refineData = { dailyHydrationTarget: parseFloat(e.dailyHydrationTarget) };

                handleSubmit(refineData);
            }
        } catch (e) {
            console.error(e);
        }
    };
    useEffect(() => {
        if (submitted) {
            setResetValue(null);
        }
    }, [submitted]);

    const enableButton = () => {
        setCanSubmit(true);
    };
    const disableButton = () => {
        setCanSubmit(false);
    };

    return (
        <React.Fragment>
            <Formsy ref={waterSettingFormRef} onValidSubmit={submitGeneralMealPlan} onValid={enableButton} onInvalid={disableButton} noValidate>
                {formError && !formError.errors ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}
                {formError && formError.errors ? (
                    <UncontrolledAlert color="danger">
                        {formError.errors.map((error, index) => (
                            <p key={index}>{error.message}</p>
                        ))}
                    </UncontrolledAlert>
                ) : null}
                <Row>
                    <Col sm="5">
                        <TextInput
                            name="dailyHydrationTarget"
                            required
                            title="Enter Hydration value (Litres)"
                            disabled={submitting}
                            validations={{
                                isNumeric: true,
                            }}
                            validationErrors={{
                                isNumeric: "Whole numbers or decimals numbers only allowed",
                            }}
                            value={submitted ? resetvalue : null}
                        />
                        {
                            <Button type="submit" color="primary" disabled={!canSubmit || submitting} className="pp3 mr-1">
                                {submitting ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <span>
                                        {"Set Hydration Value"} <MdSave size={20} />
                                    </span>
                                )}
                            </Button>
                        }
                    </Col>
                </Row>
            </Formsy>
        </React.Fragment>
    );
});

export default WaterSettingForm;
